import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Shield, LogIn } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/api/admin/auth/login`, { email, password });
      localStorage.setItem("vm_admin_token", data.token);
      localStorage.setItem("vm_admin_email", data.admin.email);
      toast.success("Benvenuto Super Admin");
      navigate("/admin");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Credenziali non valide");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#161412] via-[#231F1D] to-[#3B503A] grid place-items-center p-6">
      <div className="w-full max-w-sm bg-[#FBF9F5] rounded-3xl p-8 shadow-2xl">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#D99B26] to-[#C85A32] grid place-items-center text-white"><Shield size={26}/></div>
        <div className="mt-4 text-xs uppercase tracking-widest text-[#C85A32] font-bold">Backoffice</div>
        <h1 className="font-serif-display text-3xl font-bold mt-1 text-[#231F1D]">Super Admin</h1>
        <p className="text-sm text-[#6B625B] mt-1">Gestisci gli account dei proprietari e i loro abbonamenti.</p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email super admin" className="w-full rounded-full border border-[#E8E2D5] bg-white px-4 py-3 text-sm" required/>
          <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full rounded-full border border-[#E8E2D5] bg-white px-4 py-3 text-sm" required/>
          <button data-testid="admin-login-btn" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-[#231F1D] hover:bg-black text-[#D99B26] rounded-full py-3 font-bold disabled:opacity-50">
            <LogIn size={16}/> {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
